import {CloudName, CloudType, Environment} from '@q9elements/ui-kit/common';

export const environment: Environment = {
    production: true,
    CLOUD_NAME: CloudName.ELEMENTS,
    CLOUD_TYPE: CloudType.PUBLIC,
    ENV: 'staging',
    API_ENDPOINT: 'https://staging-api.elements-eng.cloud/api/v1',
    API_STATIC_FILE_UPLOAD: 'https://staging-upload.elements-eng.cloud:1443/api', 
    MAIN_APP_URL: 'https://staging-app.elements-eng.cloud',
    DIAGRAM_URL: 'https://staging-diagram.elements-eng.cloud',
    REPORTS_API_ENDPOINT: 'https://staging-gateway.elements-eng.cloud/report/api/v1',
    ANALYSIS_API: 'https://staging-gateway.elements-eng.cloud/dependency-analysis/api/v1/dependency-analysis',
    REPORTS_APP: 'https://staging-report.elements-eng.cloud',
    TEAM_APP: 'https://staging-spacemgt.elements-eng.cloud',
    REF_MODEL_APP: 'https://staging-refmodel.elements-eng.cloud',
    DOMAIN: 'elements-eng.cloud',
    INTERCOM_APP_ID: 'sfi4u1en',
    GA_ID: '',
    version: require('../../package.json').version,
    SENTRY_AUTH_TOKEN: '',
    SENTRY_DSN: '',
    SENTRY_ORG: '',
    SENTRY_PROJECT: 'refmodel-app',
    DATA_STRUCTURE_URL: 'https://staging-datatable.elements-eng.cloud',
    STATIC_FILES_URL: 'https://static.elements-eng.cloud',
    JAM_TEAM_ID: '',
    MCP_OAUTH_URL: 'https://staging-api.elements-eng.cloud/api/v1/oauth',
    fbConfig: {
        apiKey:'AIzaSyCIrTPqlx_vQu_WFNfkg8IUIzoAL3Ij0gI',
        authDomain:'staging-elements.firebaseapp.com',
        databaseURL: 'https://staging-elements-default-rtdb.firebaseio.com',
        storageBucket: '',
        messagingSenderId: '',
        projectId: 'staging-elements',
        appId: '1:742374870043:web:8291e098ca434728fabcbe',
        measurementId:''
    }
};                     
